import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Zap } from "lucide-react";

export const GuestTracker = ({ usage }) => {
  const { t } = useLang();
  if (!usage) return null;
  const { remaining = 0, limit = 3 } = usage;

  return (
    <div
      data-testid="guest-check-tracker"
      className="inline-flex items-center gap-2.5 rounded-full border border-slate-200 bg-slate-50 px-4 py-2"
    >
      <Zap className={`h-4 w-4 ${remaining > 0 ? "text-blue-700" : "text-slate-500"}`} />
      <span className="text-sm text-slate-600">
        {remaining > 0 ? (
          <>
            <span className="font-mono font-semibold text-slate-900">{remaining}/{limit}</span>{" "}
            {t("check.guest.left")}
          </>
        ) : (
          <span className="text-slate-500">{t("check.guest.none")}</span>
        )}
      </span>
      <div className="ml-1 flex gap-1">
        {Array.from({ length: limit }).map((_, i) => (
          <span
            key={i}
            className={`h-1.5 w-1.5 rounded-full ${i < remaining ? "bg-sky-400" : "bg-white/15"}`}
          />
        ))}
      </div>
    </div>
  );
};
